export default __webpack_public_path__ + "static/media/slider-img19.fe69807a.jpg";